/* eslint-disable @typescript-eslint/no-unused-vars */
import { Modal } from '../Modal'
import { useEffect, useState } from 'react'
import { SelectWithLabel } from '../SelectWithLabel'
import { canCreateChild, type lookup } from '../../core/types'
import { sendGet } from '../../hooks/use-fetch'
import { toast } from 'react-toastify'
import { TextWithLabel } from '../TextWithLabel'
import { useNavigate } from 'react-router'
import { Autocomplete } from '../AutoComplete'

interface NewChildValuesModalProps {
  serviceID: number
  serviceName: string
  onCancel: () => void
}

export function NewChildValuesModal (props: NewChildValuesModalProps): JSX.Element {
  const [ISDID, setISDID] = useState<number | undefined>(undefined)
  const [isdList, setISDList] = useState<Array<{ id: number, name: string, disabled: boolean }>>([])
  const [programID, setProgramID] = useState<number | undefined>(undefined)
  const [programList, setProgramList] = useState<lookup[]>([])
  const [schoolYearID, setSchoolYearID] = useState<number | undefined>(undefined)
  const [schoolYearList, setSchoolYearList] = useState<lookup[]>([])
  const nav = useNavigate()
  const temp = isdList.filter(i => i.id === ISDID)
  const selectedISD = temp.length > 0 ? temp[0] : { name: 'selected ISD', disabled: true }

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response: schoolYearList } = await sendGet('/EnrollmentSearch/GetSchoolYears', {})
      if (schoolYearList !== null) {
        setSchoolYearList(schoolYearList)
      }

      const { response, error } = await sendGet('/ServiceProviderDetails/ServiceProviderISDs', {})
      const x = response as Array<{ id: number, name: string, canCreateChild: boolean }>
      const list: Array<{ id: number, name: string, disabled: boolean }> = x.map(dat => { return { id: dat.id, name: dat.name, disabled: !dat.canCreateChild, subtext: dat.canCreateChild ? null : 'Your provider is not allowed to create children for this ISD' } })

      if (error[0] === '') {
        setISDList(list)
        if (list.length > 0) {
          setISDID(list[0].id)
        }
      }
    }
    void fetchData()
  }, [])

  useEffect(() => {
    if (ISDID !== undefined) {
      const fetchData = async (): Promise<void> => {
        const { response, error } = await sendGet(`/ServiceProviderDetails/ProgramsByCurrentProviderAndISD?isdID=${ISDID}`, {})
        if (error[0] === '') {
          setProgramList(response)
        }
      }
      void fetchData()
    }
  }, [ISDID])

  const onConfirm = (): void => {
    let ok = true
    if (programID === undefined) {
      toast.error('Please select a program.')
      ok = false
    }
    if (schoolYearID === undefined) {
      toast.error('Please select a school year.')
      ok = false
    }
    if (ISDID === undefined) {
      toast.error('There was a problem determining the ISD')
      ok = false
    }
    const temp = isdList.filter(i => i.id === ISDID)
    const selectedISD = temp.length > 0 ? temp[0] : { name: 'selected ISD', disabled: true }
    if (selectedISD.disabled) {
      toast.error(`Your service provider may not add students for the ${selectedISD.name}`)
      ok = false
    }
    if (ok) {
      nav(`/CareNetworkManagement/Edit?isdID=${ISDID ?? 0}&serviceID=${props.serviceID}&programID=${programID ?? 0}&schoolYearID=${schoolYearID ?? 0}`)
    }
  }

  const content = <>
    <TextWithLabel
      label='Service'
      name='serviceName'
      value={props.serviceName}
    />
    {isdList.length > 0 && <Autocomplete options={isdList}
      maxWidth='100%'
      width='100%'
      onChange={(e, value) => { setISDID((value?.id as number) ?? undefined) }}
      label={'ISD'}
      value={ISDID ?? ''}
      name={'ISDID'}
      required={true}
    />
    }
    <SelectWithLabel
      name="programID"
      label="Program"
      value={programID}
      width="100%"
      required={true}
      options={programList}
      onChange={(e) => { setProgramID(Number(e.target.value)) }}
    />
    <SelectWithLabel
      label='School Year'
      name='schoolYearID'
      onChange={(e) => { setSchoolYearID(Number(e.target.value)) }}
      options={schoolYearList}
      required={true}
      width='100%'
      value={schoolYearID}
    />
  </>
  return <Modal
    open={true}
    onClose={() => { props.onCancel() }}
    onConfirm={onConfirm}
    title='New Child and Enrollment'
    confirmButtonText='Continue'
    cancelButtonText='Cancel'
    confirmationContent={content}
  />
}
